var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrowaveLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "35px",
    viewBox: "0 0 45 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "37A7D819-4382-45C7-9BAF-A591EB82513C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-130.000000, -2255.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(13.000000, 900.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microwave-light",
    transform: "translate(0.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,2.5 C41.3828125,2.5 42.5,3.6171875 42.5,5 L42.5,27.5 C42.5,28.8828125 41.3828125,30 40,30 L38.75,30 L6.25,30 L5,30 C3.6171875,30 2.5,28.8828125 2.5,27.5 L2.5,5 C2.5,3.6171875 3.6171875,2.5 5,2.5 L40,2.5 Z M37.5,32.5 L37.5,33.75 C37.5,34.4375 38.0625,35 38.75,35 C39.4375,35 40,34.4375 40,33.75 L40,32.5 C42.7578125,32.5 45,30.2578125 45,27.5 L45,5 C45,2.2421875 42.7578125,0 40,0 L5,0 C2.2421875,0 0,2.2421875 0,5 L0,27.5 C0,30.2578125 2.2421875,32.5 5,32.5 L5,33.75 C5,34.4375 5.5625,35 6.25,35 C6.9375,35 7.5,34.4375 7.5,33.75 L7.5,32.5 L37.5,32.5 Z M36.25,7.5 L36.25,25 C36.25,25.6875 36.8125,26.25 37.5,26.25 C38.1875,26.25 38.75,25.6875 38.75,25 L38.75,7.5 C38.75,6.8125 38.1875,6.25 37.5,6.25 C36.8125,6.25 36.25,6.8125 36.25,7.5 Z M10,22.5 L10,10 L30,10 L30,22.5 L10,22.5 Z M7.5,9.375 L7.5,23.125 C7.5,24.1640625 8.3359375,25 9.375,25 L30.625,25 C31.6640625,25 32.5,24.1640625 32.5,23.125 L32.5,9.375 C32.5,8.3359375 31.6640625,7.5 30.625,7.5 L9.375,7.5 C8.3359375,7.5 7.5,8.3359375 7.5,9.375 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrowaveLight);
export default __webpack_public_path__ + "static/media/microwave-light.045fbc07f22ed021a93a76adbe3b33d4.svg";
export { ForwardRef as ReactComponent };